export const ATALHOS_TECLADO = `
    <strong>Imagem do cartão</strong>
    <ul>
        <li><b>Alt + Q</b> — Imagem em modo cortada</li>
        <li><b>Alt + W</b> — Imagem em modo ampliada</li>
        <li><b>Alt + A</b> — Imagem em modo original</li>
        <li><b>Alt + S</b> — Restaurar imagem</li>
        <li><b>Alt + Z</b> — Girar 180°</li>
    </ul>
    <br />
    <strong>Marcações</strong>
    <ul>
        <li><b>A</b>–<b>E</b> — Marcam a alternativa da questão em foco</li>
        <li><b>N</b> — Marca N/B (nulo/branco)</li>
        <li><b>←</b> / <b>→</b> — Navegam entre as questões</li>
        <li><b>Tab</b> — Avança para a próxima próxima questão</li>
        <li><b>Enter</b> — Confirma a digitação (com as 20 questões preenchidas)</li>
        <li><b>↑</b> / <b>↓</b> — Movem entre as alternativas da mesma questão</li>
    </ul>    
`;

export default ATALHOS_TECLADO;
